import React from 'react';
import { motion } from 'framer-motion';
import { infoSources, painPoints, selfQuestions } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Est-ce que cette situation vous parle" className="bg-obsidian text-white" data-id="element-160" data-mp="2lp55ksdk54u7">
      <div className="mx-auto max-w-5xl px-5 py-16 lg:py-24" style={{
      paddingTop: "17px",
      paddingBottom: "20px"
    }} data-id="element-161" data-mp="26wlg2ujbyvv8">
        <div className="max-w-3xl" data-id="element-162" data-mp="1xxzpqd7macjw">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-aqua" data-id="element-163" data-mp="1xwoq8pl7fqyl">
            De vrais besoins. Une préparation plus structurée.
          </p>
          <h2 className="mt-3 font-display text-4xl font-extrabold uppercase leading-none sm:text-6xl" data-id="element-164" data-mp="1nzk1chzz5he3">
            Est-ce que cette situation vous parle ?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-white/75" data-id="element-165" data-mp="1t0r5m72wryg0">
            Vous préparez un triathlon distance complète, mais chaque fois que vous essayez d'organiser votre
            entraînement, vous vous retrouvez submergé par la quantité d'informations disponibles.
          </p>
        </div>

        <div className="mt-10 grid gap-10 lg:grid-cols-[1fr_1.4fr] lg:gap-14" data-id="element-166" data-mp="1yykhbo9v9s5z">
          <div data-id="element-167" data-mp="1u12ca8yyzx39">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/45" data-id="element-168" data-mp="1tzhjoow7uo81">Vous avez</p>
            <ul className="mt-4 flex flex-wrap gap-2" data-id="element-169" data-mp="27v38auyjf5zx">
              {infoSources.map(s => <li key={s} className="rounded-lg border border-white/15 px-3 py-1.5 text-sm text-white/80" data-id="element-170" data-mp="23rx1nm7ijcsx">
                  {s}
                </li>)}
            </ul>
            <p className="mt-5 text-lg font-semibold text-ember" data-id="element-171" data-mp="1b3hrbczbtinx">
              Mais tous ces éléments ne sont pas nécessairement reliés entre eux.
            </p>
          </div>
          <div data-id="element-172" data-mp="1k3nxsewlxidl">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/45" data-id="element-173" data-mp="1k34qds4l2cdt">Vous vous demandez constamment</p>
            <ul className="mt-4 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-174" data-mp="30gcq1eyvzg4g">
              {selfQuestions.map(q => <li key={q} className="flex gap-2.5 text-[15px] leading-snug text-white/80" data-id="element-175" data-mp="2vhrsjnb0rajp">
                  <span className="font-bold text-ember" aria-hidden="true" data-id="element-176" data-mp="1t43qbdlxqz23">?</span>
                  {q}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-14 border-y border-white/10 py-10 text-center" data-id="element-177" data-mp="225bl3lp8thrf">
          <p className="text-lg text-white/60" data-id="element-178" data-mp="2240e7d0i3tw3">Ce n'est pas forcément un problème de motivation.</p>
          <p className="mx-auto mt-2 max-w-3xl font-display text-4xl font-extrabold uppercase leading-none sm:text-6xl" data-id="element-179" data-mp="272k23iynnfr3">
            C'est peut-être un problème d'<span className="text-electric" data-id="element-180" data-mp="1eh236uv5he5k">organisation</span> et de méthode.
          </p>
        </div>

        <ol className="divide-y divide-white/10" data-id="element-181" data-mp="1jek6a4mhkz5n">
          {painPoints.map(({
          icon: Icon,
          title,
          body,
          list,
          resolve
        }) => <motion.li key={title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid gap-4 py-9 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-12" data-id="element-182" data-mp="qqocb7oaxlck">
              <div className="flex items-start gap-4" data-id="element-183" data-mp="j8gkm1rbh7e7">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-ember/30 bg-ember/10 text-ember" data-id="element-184" data-mp="e7so50kbjycl">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-185" data-mp="a5xmtw2e1kyt" />
                </span>
                <h3 className="pt-1 font-display text-2xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-186" data-mp="58fjqmb1xzyq">
                  {title}
                </h3>
              </div>
              <div className="space-y-3 text-[15px] leading-relaxed text-white/70 lg:pt-1.5" data-id="element-187" data-mp="3rmfij8xun2uc">
                {body.map(b => <p key={b} data-id="element-188" data-mp="3moni1qj528ej">{b}</p>)}
                {list && <ul className="space-y-1.5" data-id="element-189" data-mp="3mlsw1ukh8fj0">
                    {list.map(item => <li key={item} className="flex gap-2.5" data-id="element-190" data-mp="3ikz6yxvasuoj">
                        <span className="text-ember" aria-hidden="true" data-id="element-191" data-mp="3dnfvu6twcy0t">—</span>
                        {item}
                      </li>)}
                  </ul>}
                {resolve && <p className="font-semibold text-white" data-id="element-192" data-mp="1hm5ns12eu1sr">{resolve}</p>}
              </div>
            </motion.li>)}
        </ol>

        <div className="mt-8 rounded-2xl bg-electric px-6 py-9 text-center" data-id="element-193" data-mp="17uhqvkn33sjw">
          <p className="mx-auto max-w-3xl font-display text-2xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-194" data-mp="17sf3l8dbgdiv">
            Si vous vous reconnaissez dans ces situations, SIGMA SMART™ a conçu une méthode pour vous aider à structurer votre préparation.
          </p>
        </div>
      </div>
    </section>;
}